import makeStyles from '@material-ui/core/styles/makeStyles';

export const useStyles = makeStyles(() => ({
  wraper: {
    overflowY: 'auto',
    paddingBottom: 20,
  },
}));
